import { UnobtrusiveValidator } from "./core/validator";

// * Export for ES module users
export default UnobtrusiveValidator;

// * Attach to window for script-tag usage
if (typeof window !== "undefined") {
    // @ts-ignore
    window.UnobtrusiveValidator = UnobtrusiveValidator;
}
